export default __webpack_public_path__ + "static/aggreko-9ac4cd0a4dab870cc8a134c50ea832e7.webp";